const BaseStepOne = () => import('@/views/purchaseProcess/baseSaleMode/tb/BaseStepOne')

export default [
  {
    name: 'baseStepOne',
    path: '/baseStepOne',
    component: BaseStepOne,
    meta: {
      title: '第一步'
    }
  }
]
